/** Motion preview fetch + cache helpers — preview-only, lazy loaded. */

import { getMotionAssetPreview } from '../../../api'
import { singleFlightCached } from './canvasRequestDedup'

export type MotionPreviewJoint = { x: number; y: number; z?: number; confidence?: number }
export type MotionPreviewFrame = { frame_index?: number; timestamp_ms?: number; joints: MotionPreviewJoint[] }

export type MotionPreviewPayload = {
  schema_version?: string
  preview_fps?: number
  frame_count?: number
  skeleton_schema?: string
  coordinate_space?: string
  frames: MotionPreviewFrame[]
}

export function loadMotionPreviewDeduped(workspaceId: string, motionAssetId: string): Promise<MotionPreviewPayload> {
  const key = `motion-preview:${workspaceId}:${motionAssetId}`
  return singleFlightCached(key, () => getMotionAssetPreview(workspaceId, motionAssetId).then((res) => res.data as MotionPreviewPayload), 30_000)
}
